module.exports = __webpack_public_path__ + "f4c13727af9161b77705b9b79942a60f.png";